import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "../../data/content";

export const FAQSection = () => {
  return (
    <section id="faq" className="section-anchor py-16 sm:py-20 bg-white border-y">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-[color:var(--brand-navy)]">
              Frequently Asked Questions
            </h2>
            <p className="mt-3 text-muted-foreground leading-relaxed">
              Answers to the questions we hear most often. Don&rsquo;t see yours? Give us a call &mdash; it&rsquo;s our
              pleasure to help!
            </p>
            <a
              href="tel:+13459280382"
              className="mt-4 inline-block text-[color:var(--brand-sky)] font-medium hover:underline"
              data-testid="faq-call-link"
            >
              Call 345-928-0382
            </a>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((faq, idx) => (
                <AccordionItem key={idx} value={`faq-${idx}`}>
                  <AccordionTrigger className="text-left font-heading text-base font-medium hover:text-[color:var(--brand-sky)]">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-muted-foreground leading-relaxed max-w-2xl">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
